import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
// Dashboard pages
import Overview from "src/pages/Dashboard/Dashboard/Overview.vue";
import Stats from "src/pages/Dashboard/Dashboard/Stats.vue";

// Pages
import User from "src/pages/Dashboard/Pages/UserProfile.vue";
import TimeLine from "src/pages/Dashboard/Pages/TimeLinePage.vue";
import Login from "src/pages/Dashboard/Pages/Login.vue";
import Register from "src/pages/Dashboard/Pages/Register.vue";
import Form from "../pages/Dashboard/HiloPages/SignUpForms/Form.vue";

import Validate from "../pages/Dashboard/Pages/Validate.vue";
import Lock from "src/pages/Dashboard/Pages/Lock.vue";
import Unauthorized from "src/pages/Dashboard/Pages/Unauthorized.vue";

// Components pages
import Buttons from "src/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "src/pages/Dashboard/Components/GridSystem.vue";
import Panels from "src/pages/Dashboard/Components/Panels.vue";
const SweetAlert = () =>
  import("src/pages/Dashboard/Components/SweetAlert.vue");
import Notifications from "src/pages/Dashboard/Components/Notifications.vue";
import Icons from "src/pages/Dashboard/Components/Icons.vue";
import Typography from "src/pages/Dashboard/Components/Typography.vue";

// Forms pages
const RegularForms = () => import("src/pages/Dashboard/Forms/RegularForms.vue");
const ExtendedForms = () =>
  import("src/pages/Dashboard/Forms/ExtendedForms.vue");
const ValidationForms = () =>
  import("src/pages/Dashboard/Forms/ValidationForms.vue");
const Wizard = () => import("src/pages/Dashboard/Forms/Wizard.vue");

// TableList pages
const RegularTables = () =>
  import("src/pages/Dashboard/Tables/RegularTables.vue");
const ExtendedTables = () =>
  import("src/pages/Dashboard/Tables/ExtendedTables.vue");
const PaginatedTables = () =>
  import("src/pages/Dashboard/Tables/PaginatedTables.vue");
// Maps pages
const GoogleMaps = () => import("src/pages/Dashboard/Maps/GoogleMaps.vue");
const FullScreenMap = () =>
  import("src/pages/Dashboard/Maps/FullScreenMap.vue");
const VectorMaps = () => import("src/pages/Dashboard/Maps/VectorMapsPage.vue");

// Calendar
const Calendar = () => import("src/pages/Dashboard/Calendar/CalendarRoute.vue");
// Charts
const Charts = () => import("src/pages/Dashboard/Charts.vue");

//Users
import AuthGroupsScopesAdmin from "../pages/Dashboard/Pages/Users/AuthGroupsScopesAdmin.vue";
import UserAuthGroupsAdmin from "../pages/Dashboard/Pages/Users/UserAuthGroupsAdmin.vue";
import { useLoginStore } from "@/stores/loginStore";
import Router from "vue-router";

//Hilo
import AddEditActiveInstructor from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditActiveInstructor.vue";
import AddEditActiveStudent from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditActiveStudent.vue";
import AddEditAircraft from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditAircraftOld.vue";
import AddEditCheckride from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditCheckride.vue";
import AddEditDpe from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditDpe.vue";
import AddEditPotentialInstructor from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditPotentialInstructor.vue";
import AddEditPotentialStudent from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditPotentialStudent.vue";
import AddEditQuote from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditQuote.vue";
import AddEditUser from "src/pages/Dashboard/HiloPages/AddEditPages/AddEditUser.vue";
import Aircraft from "@/pages/Dashboard/HiloPages/Aircraft.vue";
import AircraftDetails from "@/pages/Dashboard/HiloPages/Aircraft/AircraftDetails.vue";
import AircraftSquawk from "src/pages/Dashboard/HiloPages/Aircraft/AircraftSquawk.vue";
import Billing from "src/pages/Dashboard/HiloPages/Billing";
import CRM from "src/pages/Dashboard/HiloPages/CRM/CRMOld";
import Chat from "src/pages/Dashboard/HiloPages/Chat.vue";
import CheckrideSchedule from "src/pages/Dashboard/HiloPages/CheckrideSchedule/CheckrideScheduleOld";
import ClassroomDashboard from "@/pages/Dashboard/HiloPages/ClassroomDashboard.vue";
import ClassroomInstructor from "src/pages/Dashboard/HiloPages/ClassroomInstructor.vue";
import ClassroomStudent from "src/pages/Dashboard/HiloPages/ClassroomStudent.vue";
import Dispatch from "src/pages/Dashboard/HiloPages/Dispatch";
import DpeContactForm from "src/pages/Dashboard/HiloPages/DpeContactForm.vue";
import DpeContactInfo from "src/pages/Dashboard/HiloPages/DpeContactInfo.vue";
import HiloAI from "@/pages/Dashboard/HiloPages/HiloAssist.vue";
import HiloAdminDashboard from "@/pages/Dashboard/HiloPages/HiloAdminDashboard.vue";
import HomeScreen from "@/pages/Dashboard/HiloPages/HomeScreen.vue";
import InstructorPayroll from "src/pages/Dashboard/HiloPages/InstructorPayrollOld.vue";
import PayrollBillingPeriod from "src/pages/Dashboard/HiloPages/PayrollBillingPeriod.vue";
import Instructors from "src/pages/Dashboard/HiloPages/Instructors";
import LenderDashboard from "src/pages/Dashboard/HiloPages/LenderDashboard";
import Lender from "src/pages/Dashboard/HiloPages/Lender/Lender";
import LenderGradebook from "src/pages/Dashboard/HiloPages/Lender/tabs/AllStudents";
import Logbook from "@/pages/Dashboard/HiloPages/LogbookOld.vue";
import Maintenance from "src/pages/Dashboard/HiloPages/Maintenance";
import Maps from "src/pages/Dashboard/HiloPages/Maps";
import Masterclass from "src/pages/Dashboard/HiloPages/Masterclass";
import OAuthGoogleClassroom from "src/pages/Dashboard/HiloPages/ClassroomOAuth";
import Onboarding from "src/pages/Dashboard/HiloPages/Onboarding.vue";
import ProfileDpe from "src/pages/Dashboard/HiloPages/ProfileDpe.vue";
import ProfileInstructor from "src/pages/Dashboard/HiloPages/ProfileInstructor.vue";
import ProfileStudent from "src/pages/Dashboard/HiloPages/ProfileStudentOld.vue";
import ProfileTechnician from "src/pages/Dashboard/HiloPages/ProfileTechnician.vue";
import Reports from "src/pages/Dashboard/HiloPages/Reports";
import Reservations from "src/pages/Dashboard/HiloPages/ReservationsNew.vue";
import Schedule from "src/pages/Dashboard/HiloPages/Schedule.vue";
import ScheduleSettings from "src/pages/Dashboard/HiloPages/Schedule/ScheduleSettings.vue";
import Students from "src/pages/Dashboard/HiloPages/Students";
import TaskManager from "src/pages/Dashboard/HiloPages/TaskManager";
import CurriculumTemplates from "@/pages/Dashboard/HiloPages/Classroom/CurriculumTemplates.vue";
import CourseDetails from "@/pages/Dashboard/HiloPages/Classroom/CourseDetails/CourseDetails.vue";
import AdminClassGradeBook from "../pages/Dashboard/HiloPages/Classroom/AdminClassGradeBook.vue";
import AdminGradeBook from "../pages/Dashboard/HiloPages/Classroom/AdminGradeBook.vue";
import LenderGradeBookV2 from "@/pages/Dashboard/HiloPages/LenderGradeBook.vue";
import AdminClassView from "@/pages/Dashboard/HiloPages/Classroom/AdminClassView.vue";
import CreateAssignment from "@/pages/Dashboard/HiloPages/Classroom/CreateAssignment.vue";
import TakeAssignment from "@/pages/Dashboard/HiloPages/Classroom/TakeAssignment.vue";
import GradedAssignment from "@/pages/Dashboard/HiloPages/Classroom/GradedAssignment.vue";
import EditLesson from "@/pages/Dashboard/HiloPages/Classroom/EditLesson.vue";
import CreateLesson from "@/pages/Dashboard/HiloPages/Classroom/CreateLesson.vue";

import CreateAccount from "src/pages/Dashboard/HiloPages/SignUpForms/Steps/CreateAccount.vue";
import GeneralSettings from "../pages/Dashboard/HiloPages/Settings/GeneralSettings.vue";
import CustomizationSettings from "../pages/Dashboard/HiloPages/Settings/CustomizationSettings.vue";
import PermissionsSettings from "@/pages/Dashboard/HiloPages/Settings/PermissionSettings.vue";
import ArchivedClasses from "../pages/Dashboard/HiloPages/ArchivedClasses.vue";
// import UserSettings from "@/pages/Dashboard/HiloPages/Settings/UserSettings/UserSettings.vue";
import ConnectionSettings from "@/pages/Dashboard/HiloPages/Settings/ConnectionSettings/ConnectionSettings.vue";
import BillingSettings from "@/pages/Dashboard/HiloPages/Settings/billingSettings/BillingSettings.vue";
import SecuritySettings from "../pages/Dashboard/HiloPages/Settings/SecuritySettings.vue";
import UsageSettings from "../pages/Dashboard/HiloPages/Settings/UsageSettings.vue";
import TidyUpSettings from "../pages/Dashboard/HiloPages/Settings/TidyUpSettings.vue";
import ContentDirectorySettings from "../pages/Dashboard/HiloPages/Settings/ContentDirectorySettings.vue";
import AppSettings from "../pages/Dashboard/HiloPages/Settings/AppSettings.vue";
import AccountCopierSettings from "../pages/Dashboard/HiloPages/Settings/AccountCopierSettings.vue";
import SingleStudentGradeBook from "../pages/Dashboard/HiloPages/Classroom/SingleStudentGradeBook.vue";
import LessonPage from "../pages/Dashboard/HiloPages/Classroom/LessonPage.vue";
import Users from "@/pages/Dashboard/Pages/Users/Users.vue";
import Connect from "@/pages/Dashboard/HiloPages/Connect.vue";
import RegisteredLender from "@/pages/Dashboard/HiloPages/Connect/RegisteredLender.vue";
import FlightSchoolDetails from "../pages/Dashboard/HiloPages/FlightSchoolDetails.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      component: Buttons,
    },
    {
      path: "grid-system",
      name: "Grid System",
      component: GridSystem,
    },
    {
      path: "panels",
      name: "Panels",
      component: Panels,
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      component: SweetAlert,
    },
    {
      path: "notifications",
      name: "Notifications",
      component: Notifications,
    },
    {
      path: "icons",
      name: "Icons",
      component: Icons,
    },
    {
      path: "typography",
      name: "Typography",
      component: Typography,
    },
  ],
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      component: RegularForms,
    },
    {
      path: "extended",
      name: "Extended Forms",
      component: ExtendedForms,
    },
    {
      path: "validation",
      name: "Validation Forms",
      component: ValidationForms,
    },
    {
      path: "wizard",
      name: "Wizard",
      component: Wizard,
    },
  ],
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      component: RegularTables,
    },
    {
      path: "extended",
      name: "Extended Tables",
      component: ExtendedTables,
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      component: PaginatedTables,
    },
  ],
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      component: GoogleMaps,
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      component: FullScreenMap,
    },
    {
      path: "vector-map",
      name: "Vector Map",
      component: VectorMaps,
    },
  ],
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      component: User,
    },
    {
      path: "timeline",
      name: "Timeline Page",
      component: TimeLine,
    },
  ],
};

let hiloMenu = {
  path: "/hilo",
  component: DashboardLayout,
  redirect: "/hilo/homeScreen",
  children: [
    {
      path: "homeScreen",
      name: "Home",
      component: HomeScreen,
      meta: { requiresScope: "home" },
    },
    {
      path: "flight-school/details/:id",
      name: "Flight School Details",
      component: FlightSchoolDetails,
      props: true,
      meta: { requiresScope: "home" },
    },
    {
      path: "flight-school/lender-gradebook/:id",
      name: "LenderGradeBookV2",
      component: LenderGradeBookV2,
      meta: { requiresScope: "home" },
    },
    {
      path: "hiloAdminDashboard",
      name: "Hilo Admin Dashboard",
      component: HiloAdminDashboard,
      meta: { requiresScope: "hilo-admin-dashboard" },
    },
    {
      path: "classroomOauth",
      name: "ClassroomOauth",
      component: OAuthGoogleClassroom,
      meta: { requiresScope: "home" },
    },
    {
      path: "classroomDashboard/archivedClasses",
      name: "Archived Classes",
      component: ArchivedClasses,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "classroomDashboard",
      name: "Classroom Dashboard",
      component: ClassroomDashboard,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "adminGradeBook",
      name: "Admin Grade Book",
      component: AdminGradeBook,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "classroomDashboard/adminClassGradeBook",
      name: "Admin Class Grade Book",
      component: AdminClassGradeBook,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "singleStudentGradeBook",
      name: "Single Student GradeBook",
      component: SingleStudentGradeBook,
    },
    {
      path: "classroomDashboard/adminClassView/:id(\\d+)",
      name: "Admin Class View",
      component: AdminClassView,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "connect",
      name: "Connect",
      component: Connect,
      meta: { requiresScope: "connect" },
    },
    {
      path: "connect/registeredLender",
      name: "Registered Lender",
      component: RegisteredLender,
      meta: { requiresScope: "connect" },
    },
    {
      path: "curriculumTemplates",
      name: "Curriculum Templates",
      component: CurriculumTemplates,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "curriculumTemplates/courseDetails",
      name: "Course Details",
      component: CourseDetails,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "curriculumTemplates/courseDetails/createAssignment",
      name: "Create Assignment",
      component: CreateAssignment,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "curriculumTemplates/courseDetails/takeAssignment",
      name: "Take Assignment",
      component: TakeAssignment,
    },
    {
      path: "curriculumTemplates/courseDetails/gradedAssignment",
      name: "Graded Assignment",
      component: GradedAssignment,
    },
    {
      path: "curriculumTemplates/courseDetails/createLesson",
      name: "Create Lesson",
      component: CreateLesson,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "curriculumTemplates/courseDetails/editLesson",
      name: "Edit Lesson",
      component: EditLesson,
      meta: { requiresScope: "classroom-dashboard" },
    },
    {
      path: "classroomInstructor",
      name: "Classroom Instructor",
      component: ClassroomInstructor,
      meta: { requiresScope: "classroom-instructor" },
    },
    {
      path: "classroomStudent",
      name: "Classroom Student",
      component: ClassroomStudent,
      meta: { requiresScope: "classroom-student" },
    },
    {
      path: "profileStudent/:id?",
      name: "Profile Student",
      component: ProfileStudent,
      meta: { requiresScope: "profile-student" },
    },
    {
      path: "/hilo/classroomStudent/lessonPage",
      name: "Lesson Student",
      component: LessonPage,
      meta: { requiresScope: "classroom-student" },
    },
    {
      path: "profileInstructor/:id?",
      name: "Profile Instructor",
      component: ProfileInstructor,
      meta: { requiresScope: "profile-instructor" },
    },
    {
      path: "instructorPayroll",
      name: "Instructor Payroll",
      component: InstructorPayroll,
      meta: { requiresScope: "profile-instructor" },
    },
    {
      path: "PayrollBillingPeriod",
      name: "Payroll Billing Period",
      component: PayrollBillingPeriod,
      meta: { requiresScope: "profile-instructor" },
    },
    {
      path: "profileTechnician",
      name: "Profile Technician",
      component: ProfileTechnician,
      meta: { requiresScope: "profile-technician" },
    },
    {
      path: "profileDpe",
      name: "Profile DPE",
      component: ProfileDpe,
      meta: { requiresScope: "profile-dpe" },
    },
    {
      path: "chat",
      name: "Chat",
      component: Chat,
      meta: { requiresScope: "chat" },
    },
    {
      path: "hiloAI",
      name: "Hilo AI",
      component: HiloAI,
      meta: { requiresScope: "hilo-assist" },
    },
    {
      path: "aircraft",
      name: "Aircraft",
      component: Aircraft,
      meta: { requiresScope: "aircraft" },
    },
    {
      path: "aircraft/addEdit/:id?",
      name: "Add Edit Aircraft",
      component: AddEditAircraft,
      props: true,
      meta: { requiresScope: "aircraft" },
    },
    {
      path: "aircraft/details/:id",
      name: "Aircraft Details",
      component: AircraftDetails,
      props: true,
      meta: { requiresScope: "aircraft" },
    },
    {
      path: "aircraft/:tailNumber/squawk",
      name: "Aircraft Squawk",
      component: AircraftSquawk,
      props: true,
      meta: { requiresScope: "aircraft" },
    },
    {
      path: "dispatch",
      name: "Dispatch",
      component: Dispatch,
      meta: { requiresScope: "dispatch" },
    },
    {
      path: "maps",
      name: "Maps",
      component: Maps,
      meta: { requiresScope: "maps" },
    },
    {
      path: "logbook",
      name: "Logbook",
      component: Logbook,
      meta: { requiresScope: "logbook" },
    },
    {
      path: "lenderDashboard",
      name: "Lender Dashboard",
      component: LenderDashboard,
      meta: { requiresScope: "lender-dashboard" },
    },
    {
      path: "lender/applications",
      name: "Lender",
      component: Lender,
      meta: { requiresScope: "lender-dashboard" },
    },
    {
      path: "lender/gradebook",
      name: "Lender Gradebook",
      component: LenderGradebook,
      meta: { requiresScope: "lender-dashboard" },
    },
    {
      path: "instructors",
      name: "Instructors",
      component: Instructors,
      meta: { requiresScope: "instructors" },
    },
    {
      path: "instructors/addEditActiveInstructor/:id?",
      name: "Add Edit Active Instructor",
      component: AddEditActiveInstructor,
      props: true,
      meta: { requiresScope: "instructors" },
    },
    {
      path: "students",
      name: "Students",
      component: Students,
      meta: { requiresScope: "students" },
    },
    {
      path: "students/addEditActiveStudent/:id?",
      name: "Add Edit Active Student",
      component: AddEditActiveStudent,
      props: true,
      meta: { requiresScope: "students" },
    },
    {
      path: "crm",
      name: "CRM",
      component: CRM,
      meta: { requiresScope: "crm" },
    },
    {
      path: "crm/addEditStudent/:id?",
      name: "Add Edit Potential Student",
      component: AddEditPotentialStudent,
      props: true,
      meta: { requiresScope: "crm" },
    },
    {
      path: "crm/addEditInstructor/:id?",
      name: "Add Edit Potential Instructor",
      component: AddEditPotentialInstructor,
      props: true,
      meta: { requiresScope: "crm" },
    },
    {
      path: "crm/addEditQuote/:id?",
      name: "Add Edit Quote",
      component: AddEditQuote,
      props: true,
      meta: { requiresScope: "crm" },
    },
    {
      path: "checkrideSchedule",
      name: "Checkride Schedule",
      component: CheckrideSchedule,
      meta: { requiresScope: "checkride-schedule" },
    },
    {
      path: "checkrideSchedule/addEditCheckride/:id?",
      name: "Add Edit Checkride",
      component: AddEditCheckride,
      meta: { requiresScope: "checkride-schedule" },
    },
    {
      path: "dpeContactForm",
      name: "DPE Contact Form",
      component: DpeContactForm,
      meta: { requiresScope: "checkride-dpe-contact-form" },
    },
    {
      path: "dpeContactInfo",
      name: "DPE Contact Info",
      component: DpeContactInfo,
      meta: { requiresScope: "checkride-dpe-contact-info" },
    },
    {
      path: "dpeContactInfo/addEditDpe/:id?",
      name: "Add Edit DPE",
      component: AddEditDpe,
      meta: { requiresScope: "checkride-dpe-contact-info" },
    },
    {
      path: "maintenance",
      name: "Maintenance",
      component: Maintenance,
      meta: { requiresScope: "maintenance" },
    },
    {
      path: "reservations",
      name: "Reservations",
      component: Reservations,
      meta: { requiresScope: "reservations" },
    },
    {
      path: "reports",
      name: "Reports",
      component: Reports,
      meta: { requiresScope: "reports" },
    },
    {
      path: "billing",
      name: "Billing",
      component: Billing,
      meta: { requiresScope: "billing" },
    },
    {
      path: "masterclass",
      name: "Masterclass",
      component: Masterclass,
      meta: { requiresScope: "masterclass" },
    },
    {
      path: "taskManager",
      name: "Task Manager",
      component: TaskManager,
      meta: { requiresScope: "task-manager" },
    },
    {
      path: "schedule",
      name: "Schedule",
      component: Schedule,
      meta: { requiresScope: "flight-schedule" },
    },
    {
      path: "scheduleSettings",
      name: "Schedule Settings",
      component: ScheduleSettings,
      meta: { requiresScope: "flight-schedule" },
    },
  ],
};

let settingsMenu = {
  path: "/settings",
  component: DashboardLayout,
  redirect: "/settings/userSettings",
  children: [
    {
      path: "generalSettings",
      name: "GeneralSettings",
      component: GeneralSettings,
      meta: { requiresScope: "settings" },
    },
    {
      path: "customizationSettings",
      name: "CustomizationSettings",
      component: CustomizationSettings,
      meta: { requiresScope: "settings" },
    },
    {
      path: "usersSettings",
      name: "UserSettings",
      // component: UserSettings,
      component: Users,
      meta: { requiresScope: "settings" },
    },
    {
      path: "billingSettings",
      name: "BillingSettings",
      component: BillingSettings,
      meta: { requiresScope: "settings" },
    },
    {
      path: "permissionSettings",
      name: "PermissionsSettings",
      component: PermissionsSettings,
    },
    {
      path: "connectionSettings",
      name: "ConnectionsSettings",
      component: ConnectionSettings,
    },
    {
      path: "securitySettings",
      name: "SecuritySettings",
      component: SecuritySettings,
    },
    {
      path: "usageSettings",
      name: "UsageSettings",
      component: UsageSettings,
    },
    {
      path: "tidyUpSettings",
      name: "TidyUpSettings",
      component: TidyUpSettings,
    },
    {
      path: "contentDirectorySettings",
      name: "ContentDirectorySettings",
      component: ContentDirectorySettings,
    },
    {
      path: "appSettings",
      name: "AppSettings",
      component: AppSettings,
    },
    {
      path: "accountCopierSettings",
      name: "AccountCopierSettings",
      component: AccountCopierSettings,
    },
  ],
};

const usersMenu = {
  path: "/users",
  component: DashboardLayout,
  children: [
    {
      path: "userAuthGroupsAdmin",
      name: "Authentication Groups",
      component: UserAuthGroupsAdmin,
      meta: { requiresScope: "auth-groups" },
    },
    {
      path: "users/addEditUser/:id?",
      name: "Add Edit User",
      component: AddEditUser,
      props: true,
      meta: { requiresScope: "crm" },
    },
    {
      path: "authGroupsScopeAdmin",
      name: "User Scopes",
      component: AuthGroupsScopesAdmin,
      meta: { requiresScope: "user-scopes" },
    },
  ],
};

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login,
};

let registerPage = {
  path: "/register",
  name: "Register",
  component: Register,
};

let signUpPage = {
  path: "/signup",
  name: "Sign Up",
  component: Form,
};

let validatePage = {
  path: "/validate",
  name: "Validate",
  component: Validate,
};

let lockPage = {
  path: "/lock",
  name: "Lock",
  component: Lock,
};

let onboardingPage = {
  path: "/onboarding/:id/:onboardingKey",
  name: "Onboarding",
  component: Onboarding,
};

let unauthorizedPage = {
  path: "/unauthorized",
  name: "Unauthorized",
  component: Unauthorized,
};

let createAccountPage = {
  path: "/create-account",
  name: "CreateAccount",
  component: CreateAccount,
};

const routes = [
  {
    path: "/",
    redirect: "/hilo/homeScreen",
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  hiloMenu,
  usersMenu,
  settingsMenu,
  loginPage,
  registerPage,
  signUpPage,
  validatePage,
  lockPage,
  onboardingPage,
  unauthorizedPage,
  createAccountPage,
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/overview",
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview,
      },
      {
        path: "stats",
        name: "Stats",
        component: Stats,
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar,
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
      },
    ],
  },
  { path: "*", component: NotFound },
];

export default routes;

export const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/register",
    "/validate",
    "/signup",
    "/create-account",
  ];
  const isOnboardingPage = to.path.startsWith("/onboarding/");
  const authRequired = !publicPages.includes(to.path) && !isOnboardingPage;
  const store = useLoginStore();
  const loggedIn = store.getLoggedIn;

  if (authRequired && !loggedIn) {
    next("/login");
  } else {
    if (to.matched.some((record) => record.meta.requiresScope)) {
      const requiredScope = to.meta.requiresScope;
      const userScopes = store.getAppScopes;

      if (userScopes.some((scope) => scope.name === requiredScope)) {
        next();
      } else {
        next("/unauthorized");
      }
    } else {
      next();
    }
  }
});
